import { render, staticRenderFns } from "./LahanUmumDistributionLoadingLine.vue?vue&type=template&id=020ea293"
import script from "./LahanUmumDistributionLoadingLine.vue?vue&type=script&lang=js"
export * from "./LahanUmumDistributionLoadingLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports